/* unplugin-vue-components disabled */import script from "./WOFerryman.vue?vue&type=script&setup=true&lang=js"
export * from "./WOFerryman.vue?vue&type=script&setup=true&lang=js"

import "./WOFerryman.vue?vue&type=style&index=0&id=4d66e69d&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d66e69d"]])

export default __exports__